<template lang="pug">
  LayoutDefault
    .page: .container-fluid
      .section: .row
        .col-6
          .heading--section.pad_t--10 Watchlist

        .col-6.text-right
          button.button.button-primary.button_standard.button_lg(v-b-modal.add_wathclist) Add Watchlist

      Loading(:isLoading="isDataLoading", type="bar")
        template(v-if="watchlists.length === 0")
          MessageBar(type="warning")
            | You currently do not have any watchlist. Start by creating a watchlist now.

        template(v-else)
          b-tabs.break-md
            template(v-for="(watchlist, index) in watchlists")
              b-tab(:title='`${watchlist.name}`')
                .section: .card: .card--body
                  .row
                    .col-lg-6
                      .heading--h4.pad_t--5.text__uppercase {{ watchlist.name }}
                    .col-lg-6.align__right.align__left-md.pad_t--15-md
                      b-button-group
                        b-button(variant="primary", @click='SHOW_ADD_STOCK_MODAL(watchlist)')
                          i.fa.fa-plus.mr-2(style="position: relative; top: 2px;")
                          span.text__uppercase.text--size_12: strong Add Stock &nbsp;
                        b-button(variant="danger", @click='SHOW_DELETE_PROMPT(watchlist)')
                          i.fa.fa-trash.mr-2(style="position: relative; top: 2px;")
                          span.text__uppercase.text--size_12: strong Delete watchlist
                  
                  DataTable.mt-4(
                    :records="watchlist.counters", 
                    :headers="headers", 
                    :emptyDisplayMessage="`You currently do not have any stock in your ${watchlist.name} watchlist. Add a stock now.`",
                    :displayItemsPerPage="false",
                    :displayPagination="false",
                  )
                    template(v-slot:slot-for-currentPrice="item")
                      | {{ item.record.counterDto.data[0].attributes.currentPrice }}

                    template(v-slot:slot-for-pnl="item")
                      | {{ CALCULATE_PNL(item.record.counterDto.data[0].attributes.currentPrice, item.record.price) }}

                    template(v-slot:slot-for-pnlPercent="item")
                      | {{ CALCULATE_PNL_PERCENT(item.record.counterDto.data[0].attributes.currentPrice, item.record.price) }}

                    template(v-slot:slot-for-msRating="item")
                      a(v-if="item.record.counterDto.data[0].attributes", :href="item.record.counterDto.data[0].attributes.morningStarResearchUrl", target="_blank")
                        template(v-for="index in Number(item.record.counterDto.data[0].attributes.morningStarRating[0].QuantitativeStarRating)")
                          Star

                    template(v-slot:slot-for-msFairValue="item")
                      template(v-if="item.record.counterDto.data[0].attributes")
                        | {{ item.record.counterDto.data[0].attributes.morningStarRating[0].QuantitativeFairValue | decimal }}
                        CircleDownloadPdf(:url="item.record.counterDto.data[0].attributes.morningStarResearchUrl", variant="secondary", ml="8")

                    template(v-slot:slot-for-removeRecord="item")
                      a.link__primary_light(href="#", @click.prevent="REMOVE_STOCK({ id: item.record.id })") Remove



      //- Add stock modal
      b-modal(ref='addStockModal', hide-footer, hide-header)
        .modal--container
          ModalClose(@click.native="$refs.addStockModal.hide()")
          .pad_b--10.text--size_17
            strong Add stock to watchlist
          SelectSingleStock(@stockSelected="ADD_STOCK", ref="selectSingleStock", :dropdownColWidth="8", :buttonColWidth="4")
        

      //- Remove wathclist modal
      b-modal(ref='deleteWatchlistModal', hide-footer, hide-header)
        .modal--container
          ModalClose(@click.native="CLOSE_DELETE_PROMPT")
          | Are you sure that you would like to remove the <strong>{{ deleteWatchlist.name }}</strong> watchlist?
          .pad_t--15
            button.button.button-neutral.button_standard.mr-2(@click="CLOSE_DELETE_PROMPT")
              | Cancel
            button.button.button-secondary.button_standard(@click="DELETE_WATCHLIST")
              | Yes, Remove

      //- Add watchlist modal
      b-modal#add_wathclist(ref="add_wathclist", hide-footer, hide-header)
        .modal--container
          ModalClose(@click.native="$refs.add_wathclist.hide()")
          .pad_b--15.text--size_17
            strong Add a new watchlist
          b-form-input#watchlist_name(type='text', placeholder='Enter your desired watchlist name', v-model="watchlistName")
          .pad_t--15
            button.button.button-success.button_standard(@click="CREATE_WATCHLIST", :disabled="watchlistName === ''")
              | Create watchlist
</template>




<script>
import numeral from 'numeral';

import requestHandlers from '../mixins/requestHandlers';

import allFilters from '../lib/filters';

import SelectSingleStock from '../components/SelectSingleStock';
import DataTable from '../components/DataTable';
import MessageBar from '../components/MessageBar';
import CircleDownloadPdf from '../components/CircleDownloadPdf';
import Loading from '../components/Loading';
import Star from '../components/Star';
import ModalClose from '../components/ModalClose';


export default {
  name: 'watchlist',

  mixins: [requestHandlers],

  components: { 
    SelectSingleStock,
    DataTable,
    Loading,
    Star,
    MessageBar,
    CircleDownloadPdf,
    ModalClose
  },

  data() {
    return {
      watchlists: [],
      watchlistName: '',

      deleteWatchlist: {
        name: null,
        id: null,
      },
      addStock: {
        selectedStock: null,
        watchlistName: null,
        watchlistId: null,
      },
      headers: [
        {
          id: 'createdAt',
          text: 'Date Added',
          sortable: true,
          type: 'string',
        },
        {
          id: 'counter',
          text: 'Stocks',
          sortable: true,
          type: 'counter',
        },
        {
          id: 'price',
          text: 'Added Price',
          sortable: true,
          type: 'number',
          colAlignment: 'center',
        },
        {
          id: 'currentPrice',
          text: 'Current Price',
          type: 'custom_slot',
          colAlignment: 'center',
        },
        {
          id: 'pnl',
          text: 'Gain / (Loss)',
          type: 'custom_slot',
          colAlignment: 'center',
        },
        {
          id: 'pnlPercent',
          text: 'Gain / (Loss) %',
          type: 'custom_slot',
          colAlignment: 'center',
        },
        {
          id: 'msRating',
          text: 'Morningstar Ratings',
          type: 'custom_slot',
          colAlignment: 'center',
          colWidth: 11,
        },
        {
          id: 'msFairValue',
          text: 'Morningstar Fair Value',
          type: 'custom_slot',
          colAlignment: 'center',
          colWidth: 10,
        },
        {
          id: 'removeRecord',
          text: '',
          type: 'custom_slot',
          colAlignment: 'center',
        },
      ]
    }
  },

  computed: {
  },

  methods: {
    CALCULATE_PNL(currentPrice, addedPrice) {
      if(typeof currentPrice !== 'number' || typeof addedPrice !== 'number') {
        return 0;
      }
      return numeral(currentPrice - addedPrice).format("0.000");
    },

    CALCULATE_PNL_PERCENT(currentPrice, addedPrice) {
      if(typeof currentPrice !== 'number' || typeof addedPrice !== 'number') {
        return 0;
      };

      // Formula copy paste from chin wei's code
      let _percent = (( currentPrice / addedPrice ) - 1.00) * 100;

      if(isNaN(_percent)) {
        return 0;
      }

      return numeral(_percent).format("0.000");
    },

    SHOW_DELETE_PROMPT(watchlist) {
      let { id, name } = watchlist;
      this.deleteWatchlist.name = name;
      this.deleteWatchlist.id = id;

      this.$refs.deleteWatchlistModal.show();
    },

    CLOSE_DELETE_PROMPT() {
      this.$refs.deleteWatchlistModal.hide();
    },

    DELETE_WATCHLIST() {
      this.$axios.delete(`/Watchlists/${this.deleteWatchlist.id}`)
      .then(response => {
        this.FETCH_WATCHLIST();
        this.CLOSE_DELETE_PROMPT();
      })
      .catch(err => { console.log(err) });
    },



    SHOW_ADD_STOCK_MODAL(watchlist) {
      let { id, name } = watchlist;
      this.addStock.watchlistName = name;
      this.addStock.watchlistId = id;

      this.$refs.addStockModal.show();
    },

    CLOSE_ADD_STOCK_MODAL() {
      this.$refs.addStockModal.hide();
    },


    ADD_STOCK(stockCode) {
      if(stockCode == null) {
        return;
      }

      let payload = {
        WatchlistId: this.addStock.watchlistId,
        CounterCode: stockCode,
      };

      this.$axios.post('/Watchlists/Counters', payload)
      .then(response => {
        if(response.status === 201) {
          this.$refs.selectSingleStock.RESET();
          this.FETCH_WATCHLIST();
          this.CLOSE_ADD_STOCK_MODAL();
        }
      })
      .catch(error => this.HANDLE_ERROR_GENERIC(error))
    },

    REMOVE_STOCK(payload) {
      let { id } = payload;

      if(!id) { 
        return; 
      }

      this.$axios.delete(`/Watchlists/Counters/${id}`)
      .then(response => {
        if(response.status === 204) {
          this.FETCH_WATCHLIST();
        }
      })
      .catch(error => this.HANDLE_ERROR_GENERIC(error))
    },


    FETCH_WATCHLIST() {
      this.REQUEST_INIT();
      this.$axios.get('/Watchlists')
      .then(response => {
        if(response.status === 200) {
          this.watchlists = response.data;
          this.FETCH_MORNINGSTAR_RESERACH_URL(this.watchlists);
        }
      })
      .catch(error => this.HANDLE_ERROR_GENERIC(error))
      .then(response => this.REQUEST_FINALLY());
    },

    CREATE_WATCHLIST() {
      let payload = { 
        Name: this.watchlistName
      };

      this.$axios.post('/Watchlists', payload)
      .then(response => {
        if(response.status === 201) {
          this.watchlistName = '';
          this.FETCH_WATCHLIST();
          this.$refs.add_wathclist.hide()
        }
      })
      .catch(error => this.HANDLE_ERROR_GENERIC(error))
    },

    FETCH_MORNINGSTAR_RESERACH_URL(watchlists) {
      watchlists.forEach(watchlist => {
        watchlist.counters.forEach(counter => {
          let stockCode = counter.counterDto.data[0].id;
          let url = counter.counterDto.data[0].attributes.morningStarResearchUrl;

          if (url == null) {
            this.$axios.get('/Counters/MorningstarResearchUrl?stockCode=' + stockCode)
              .then(response => {
                if(response.status === 200) {
                  counter.counterDto.data[0].attributes.morningStarResearchUrl = response.data;
                }
              })
              .catch(error => this.HANDLE_ERROR_GENERIC(error))
              .then(response => this.REQUEST_FINALLY());
          }
        });
      })
    }
  },

  created() {
    this.FETCH_WATCHLIST();
  },

  filters: {
    decimal: allFilters.decimal,
  },
}
</script>




<style lang="scss">

</style>
